import api from "./apis/api";
import { logger } from "../utils/utils";
import storage from "../utils/storage";

class AuthService {
  callLogInApi(loginReq) {
    logger("AuthService", "callLogInApi");
    return api.auth
      .callLogInApi(loginReq)
      .then(async (loginData) => {
        const { access_token, user,refresh_token } = loginData;
        await Promise.all([
          storage.set("token", access_token),
          // JSON.stringify(undefined) would store the text "undefined", which breaks JSON.parse elsewhere
          user ? storage.set("user", JSON.stringify(user)) : storage.remove("user"),
          storage.set("isLoggedIn", loginReq.keepLogin),
          storage.set("refresh-token",refresh_token)
        ]);
        return loginData;
      }).catch((e) => {
        throw e;
      });
  }

  callForgotPasswordApi(loginReq) {
    return api.auth.callForgotPasswordApi(loginReq);
  }
  
  callResetPasswordApi(loginReq) {
    return api.auth.callResetPasswordApi(loginReq);
  }
}

export default new AuthService();
